export const PAGER_DEFAULT_PAGE = 0;
export const PAGER_DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
